import Api from '@/services/api';

// Le backend stocke le mark-up en fraction (0.12 pour 12%) pour éviter toute division en base/calcul.
// Cette couche convertit vers/depuis le pourcentage humain (12) utilisé par les composants Ak.
const toFraction = (percent) => (percent == null ? null : percent / 100);
const toPercent = (fraction) => (fraction == null ? null : Math.round(fraction * 100000) / 1000);

const withPercent = (markup) => (markup ? {...markup, percent: toPercent(markup.percent)} : markup);

export {toPercent, toFraction};

export default {
  updateGeneralMarkup(otaAccountId, percent) {
    return Api()
      .put('/otatoken/' + otaAccountId + '/markup', {percent: toFraction(percent)})
      .then((res) => res.data);
  },
  getSpecificMarkup(accommodationId) {
    return Api()
      .get('/accommodations/' + accommodationId + '/markup')
      .then((res) => ({
        specific: withPercent(res.data.specific),
        generalMarkupPercentForReference: toPercent(res.data.generalMarkupPercentForReference),
      }));
  },
  createSpecificMarkup(accommodationId, payload) {
    return Api()
      .post('/accommodations/' + accommodationId + '/markup', {...payload, percent: toFraction(payload.percent)})
      .then((res) => res.data);
  },
  deleteSpecificMarkup(markupId) {
    return Api()
      .delete('/markup/' + markupId)
      .then((res) => res.data);
  },
  getSpecificMarkupHistory(accommodationId) {
    return Api()
      .get('/accommodations/' + accommodationId + '/markup/history')
      .then((res) => res.data.map(withPercent));
  },
  applyBatch(filter, percent, dateBasis, dateStart, dateEnd, mergeStrategy) {
    return Api()
      .post('/markup/batch', {
        filter,
        percent: toFraction(percent),
        dateBasis,
        dateStart,
        dateEnd,
        mergeStrategy,
      })
      .then((res) => res.data);
  },
};
